module.exports = __webpack_public_path__ + "img/mnyplogo_white_tr.c13090e9.svg";